import Constants from 'config/Constants';
import { BlockLayoutBlock } from 'pages/approvals/modals/ApprovalItems/blocks/BlockLayoutBlock';
import { FileBlock } from 'pages/approvals/modals/ApprovalItems/blocks/FileBlock';
import { LabelBlock } from 'pages/approvals/modals/ApprovalItems/blocks/LabelBlock';
import { TableBlock } from 'pages/approvals/modals/ApprovalItems/blocks/TableBlock';
import { TextBlock } from 'pages/approvals/modals/ApprovalItems/blocks/TextBlock';

/**
 * @param {import('models/documents.models').Block} block
 * @param {import('models/documents.models').BaseBlock} [baseBlock]
 * @param {number} areaId
 * @param {number} documentId
 * @param {import('models/documents.models').Block[]} areaBlocks
 * @param {import('models/documents.models').BaseBlock[]} baseBlocks
 * @param {boolean} hideChanges
 */
export function Block({ block, baseBlock, areaId, documentId, areaBlocks = [], baseBlocks = [], hideChanges = false }) {
    if (block.type === Constants.blockTypes.text) {
        return <TextBlock content={!hideChanges && baseBlock ? baseBlock.renderedDiffContent : block.latestContent} />;
    }

    if (block.type === Constants.blockTypes.table) {
        return <TableBlock areaId={areaId} documentId={documentId} />;
    }

    if (block.type === Constants.blockTypes.blockLayout) {
        return (
            <BlockLayoutBlock block={block} areaBlocks={areaBlocks} baseBlocks={baseBlocks} hideChanges={hideChanges} />
        );
    }

    if (block.type === Constants.blockTypes.file) {
        return <FileBlock block={block} />;
    }

    if (block.type === Constants.blockTypes.label) {
        return <LabelBlock block={block} />;
    }

    return null;
}
